<template>
  <div>
    <h4 v-if="transferInfoSteps.length > 0">转签列表</h4>
    <el-steps v-if="transferInfoSteps.length > 0" :active="transferInfoSteps.length" finish-status="success" align-center>
      <el-step v-for="(item, index) in transferInfoSteps" :key="index">
        <span style="font-size: 14px" slot="title">{{ item }}</span>
      </el-step>
    </el-steps>
    <div style="height: 10px"></div>
    <el-table :data="transferInfoTable" v-if="transferInfoTable.length > 0" border>
      <el-table-column prop="name" label="转签员工" width="120"></el-table-column>
      <el-table-column prop="time" label="转签时间" width="160"></el-table-column>
      <el-table-column prop="comments" label="转签备注"></el-table-column>
    </el-table>

  </div>
</template>

<script>
export default {
  name: 'PendingTransferInfoView',

  props: ['transferInfoData'],

  mounted() {
    // this.loadTestData()
    this.loadData()
  },

  data() {
    return {
      transferInfoTable: [],
      transferInfoSteps: [],
      transferInfoStepActive: 0,
    };
  },

  watch: {
    "transferInfoData": function (val, oldVal) {
      // this.loadTestData()
      this.loadData()
    },
  },

  methods: {
    loadData() {
      this.transferInfoTable = []
      this.transferInfoSteps = []
      this.transferInfoStepActive = 0

      if (this.transferInfoData == null || this.transferInfoData.length === 0) {
        return
      }

      for (let i = 0; i < this.transferInfoData.length; i++) {
        let item = this.transferInfoData[i]
        if (i === 0) {
          this.transferInfoSteps.push(item.fromEmployeeName)
        }
        this.transferInfoSteps.push(item.toEmployeeName)

        this.transferInfoTable.push({
          name: item.fromEmployeeName,
          time: this.getShowTime(item.createTime),
          comments: item.comments
        })
      }

    },

    getShowTime(value) {
      if (value == null) {
        return
      }
      return value.substring(2, 10) + ' ' + value.substring(11, 16)
    },
    loadTestData() {
      this.transferInfoTable = [
        {
          name: "张三",
          time: "2020-01-01 12:00",
          comments: "转签备注"
        },
        {
          name: "李四",
          time: "2020-01-01 12:00",
          comments: "转签备注"
        },
        {
          name: "王五",
          time: "2020-01-01 12:00",
          comments: "转签备注"
        },
        {
          name: "赵六",
          time: "2020-01-01 12:00",
          comments: "转签备注"
        },
      ]

      this.transferInfoSteps = [
        "张三",
        "李四",
        "王五",
        "赵六",
      ]

      this.transferInfoStepActive = 4
    }
  }
}

</script>

<style scoped lang="less">

.drawer-title {
  padding-left: 10px;
  padding-top: 10px;
}

.input-short {
  width: 150px;
}

.input-long {
  width: 300px;
}

.grid-content {
  //padding-left: 8px;
  margin: 8px 8px 8px 20px;

}

.input-item-box {
  padding-bottom: 8px;
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
}

.input-description {
  display: inline-block;
  width: 80px;
}

.input-description-long {
  display: inline-block;
  width: 120px;
}


</style>
